import RatingStars from 'components/rating/rating-stars';
import StatusLabel from 'components/rating/status-label';
import { AppTheme } from 'types/common';
import { Rating, RatingLevel } from 'types/rating';
import { RatingStarsMode } from 'utils/constants/rating';
import './UserRating.scss';

type Props = Pick<Rating, 'intStars' | 'starThirds' | 'levelTitle'> & {
	className?: string;
	ratingStarsMode?: RatingStarsMode;
	theme?: AppTheme;
};

const UserRating = (
	{ intStars, levelTitle, ratingStarsMode = RatingStarsMode.BLACK, starThirds, theme = AppTheme.LIGHT }: Props,
): JSX.Element => (
	<div className="user-rating">
		<StatusLabel levelTitle={levelTitle} />

		{levelTitle !== RatingLevel.PARTNER && (
			<RatingStars
				intStars={intStars ?? 0}
				ratingStarsMode={ratingStarsMode}
				starThirds={starThirds ?? 0}
				theme={theme}
			/>
		)}
	</div>
);

export default UserRating;
